export default __webpack_public_path__ + "e6cba535c3ff4775267ba40faa765da8.svg";